module.exports = __webpack_public_path__ + "img/top.ddb17ae7.png";